"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.buttonToText = exports.buttonToMjml = void 0;

var _base = require("./common/base");

var _formatDefinition = require("./common/formatDefinition");

var buttonToMjml = function buttonToMjml(item, blockRenderer, isTopLevelNode) {
  var mjButton = (0, _base.toMjml)('mj-button', item.properties, _formatDefinition.EDIE_PROPS[_formatDefinition.EDIE_BLOCK_TYPE.BUTTON]); // mj-button NOT allowed in mj-body, so in case this is what EDIE
  // defines, we need to enclose in section/column

  return isTopLevelNode ? (0, _base.encloseInMjmlSection)(mjButton) : mjButton;
};

exports.buttonToMjml = buttonToMjml;

var buttonToText = function buttonToText(item) {
  var result = item.properties.content + '\r\n';

  if (item.properties.href) {
    result += "[".concat(item.properties.href, "]\r\n");
  }

  return result;
};

exports.buttonToText = buttonToText;